module.exports = __webpack_public_path__ + "img/loginimg.149c7c85.svg";